// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home Page Styles - OLED Technical */

.home-container {
  max-width: 1400px;
  margin: 0 auto;
  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-primary);
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Header Section */
.home-header {
  margin-bottom: 2rem;
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 1.5rem;
}

.home-title {
  font-family: var(--font-heading);
  font-size: 2rem;
  font-weight: 600;
  color: var(--text-heading);
  margin-bottom: 0.5rem;
}

.home-subtitle {
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--text-secondary);
}

.btn-refresh-mini {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-out;
}

.btn-refresh-mini:hover:not(:disabled) {
  background: var(--bg-secondary);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  transform: translateY(-1px);
}

.btn-refresh-mini:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-refresh-mini svg {
  transition: transform 0.4s ease;
}

.btn-refresh-mini:hover:not(:disabled) svg {
  transform: rotate(180deg);
}

/* Logs Section */
.home-logs-section {
  background: var(--bg-secondary);
  border-radius: 12px;
  padding: 24px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  margin-bottom: 2rem;
}

.home-logs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.home-logs-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.home-logs-icon {
  width: 40px;
  height: 40px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-primary);
}

.home-logs-title {
  font-family: var(--font-heading);
  font-size: 1.2rem;
  font-weight: 650;
  color: var(--text-heading);
  margin: 0;
}

.home-logs-subtitle {
  font-family: var(--font-data);
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin: 2px 0 0 0;
  line-height: 1.15;
  font-weight: 500;
}

/* Log Items & Staggered Animation */
@keyframes slideUpFade {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.home-logs-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.home-log-item {
  background: var(--bg-primary);
  border-radius: 12px;
  border: 1px solid var(--border-color);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  overflow-anchor: none;
  contain: layout style;
}

.home-log-item:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.home-log-item.expanded {
  border-color: var(--accent-primary);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
}

.log-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.log-item-main-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.log-type-icon-wrapper {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.home-log-item:hover .log-type-icon-wrapper {
  transform: scale(1.05);
}

.log-item-title-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.log-item-action-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.log-item-action-row .copy-btn {
  opacity: 0.6;
}

.log-item-action-row:hover .copy-btn {
  opacity: 0.85;
}

.log-item-action {
  font-family: var(--font-heading);
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-heading);
  line-height: 1.2;
}

.log-type-badge {
  font-family: var(--font-data);
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.log-item-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.log-item-date {
  font-family: var(--font-data);
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.btn-log-expand {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.home-log-item:hover .btn-log-expand {
  background: rgba(37, 99, 235, 0.1);
  color: var(--accent-primary);
}

.btn-log-expand.expanded {
  background: var(--accent-primary);
  color: #fff;
  transform: rotate(180deg);
}

/* Expanded body */
.log-item-body {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.log-item-body.open {
  grid-template-rows: 1fr;
}

.log-item-body > div {
  overflow: hidden;
}

.log-item-body-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.log-item-details {
  padding: 0 20px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.log-item-reason {
  margin: 0 20px;
  padding: 0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-family: var(--font-body);
  font-size: 0.9rem;
  color: var(--text-secondary);
  line-height: 1.5;
}

.reason-icon {
  color: var(--accent-warning);
  margin-top: 2px;
  flex-shrink: 0;
}

.log-item-actors-compact {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 0 20px 20px 20px;
  font-family: var(--font-data);
  font-size: 0.85rem;
}

.log-actor-compact, .log-target-compact {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--bg-tertiary);
  padding: 6px 12px;
  border-radius: 20px;
  color: var(--text-secondary);
}

.log-actor-name, .log-target-name {
  color: var(--text-primary);
  font-weight: 600;
}

.log-item-actors-full {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.log-actor-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  transition: all 0.2s ease;
}

.log-actor-row.clickable:hover {
  cursor: pointer;
  border-color: rgba(37, 99, 235, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
}

.log-actor-row-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.log-actor-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--accent-primary);
}

.log-actor-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.log-actor-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.log-actor-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-secondary);
  letter-spacing: 0.5px;
}

.log-actor-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
}

.log-actor-role, .log-target-role {
  padding: 4px 8px;
  background: rgba(37, 99, 235, 0.1);
  color: var(--accent-primary);
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Payload Accordion */
.log-item-payload {
  border: 1px solid var(--border-color);
  border-radius: 10px;
  overflow: hidden;
  background: var(--bg-primary);
  overflow-anchor: none;
}

.payload-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: rgba(0,0,0,0.02);
  border: none;
  border-bottom: 1px solid transparent;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.payload-header:hover {
  background: rgba(0,0,0,0.04);
  color: var(--text-primary);
}

.payload-chevron {
  transition: transform 0.3s ease;
}

.payload-chevron.open {
  transform: rotate(180deg);
}

.payload-body {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.payload-body.open {
  grid-template-rows: 1fr;
  border-top: 1px solid var(--border-color);
}

.payload-content {
  overflow: hidden;
}

.log-item-payload pre {
  padding: 16px;
  margin: 0;
  font-family: var(--font-data, monospace);
  font-size: 0.85rem;
  color: var(--text-primary);
  overflow-x: auto;
  line-height: 1.5;
  background: var(--bg-tertiary);
}

.home-logs-empty {
  text-align: center;
  padding: 48px;
  color: var(--text-secondary);
}

.empty-icon {
  color: var(--border-color);
  margin-bottom: 16px;
}

/* Cleaned up loader */
.home-logs-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  color: var(--text-secondary);
  font-family: var(--font-data);
  font-size: 0.9rem;
  gap: 16px;
}

@media (max-width: 768px) {
  .home-log-item {
    border-radius: 8px;
  }
  
  .log-item-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .log-item-header-right {
    width: 100%;
    justify-content: space-between;
  }

  .log-item-actors-compact {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .log-item-actors-full {
    grid-template-columns: 1fr;
  }
}

/* ============================ Home tabs ============================ */
.home-tabs {
  display: inline-flex;
  gap: 4px;
  margin-bottom: 24px;
  padding: 5px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.home-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 20px;
  background: transparent;
  border: none;
  border-radius: 9px;
  position: relative;
  overflow: hidden;
  font-family: var(--font-heading);
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
  color: var(--text-secondary);
  cursor: pointer;
  transition: color 0.25s ease;
}

.home-tab:hover:not(.active) {
  color: var(--text-primary);
}

.home-tab.active {
  color: #fff;
}

.home-tab-active-bg {
  position: absolute;
  inset: 0;
  background: var(--accent-primary);
  border-radius: 9px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
  z-index: 0;
  pointer-events: none;
}

.home-tab-content {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* ===================== Order moderation logs ===================== */
.order-log-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.order-log-badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.order-log-attempts {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: var(--font-data);
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 2px 8px;
}

/* CSV export buttons */
.order-logs-export-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.order-logs-export-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

/* AI error block */
.order-log-error {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 4px 0 18px;
  padding: 16px 18px 16px 28px;
  background: rgba(239, 68, 68, 0.06);
  border: 1px solid rgba(239, 68, 68, 0.22);
  border-radius: 10px;
}

.order-log-error::before {
  content: "";
  position: absolute;
  left: 14px;
  top: 14px;
  bottom: 14px;
  width: 3px;
  border-radius: 99px;
  background: var(--accent-error);
}

.order-log-error-header {
  display: inline-flex;
  align-items: center;
  gap: 9px;
}

.order-log-error-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  color: var(--accent-error);
  background: rgba(239, 68, 68, 0.12);
  border-radius: 6px;
}

.order-log-error-label {
  font-family: var(--font-data);
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--accent-error);
}

.order-log-error-text {
  padding-left: 31px;
  font-size: 0.88rem;
  line-height: 1.5;
  color: var(--text-primary);
  word-break: break-word;
}

.order-log-meta {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* User id row */
.order-log-id {
  font-family: var(--font-data);
  font-size: 0.85rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px;
  word-break: break-all;
}

.order-log-row-chevron {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--text-secondary);
  opacity: 0.5;
  transition: transform 0.2s ease, opacity 0.2s ease, color 0.2s ease;
}

.log-actor-row.clickable:hover .order-log-row-chevron {
  opacity: 1;
  color: var(--accent-primary);
  transform: translateX(3px);
}

@media (max-width: 768px) {
  .home-tabs {
    display: flex;
    width: 100%;
  }

  .home-tab {
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/home.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,iBAAiB;EACjB,cAAc;EACd,mDAAmD;EACnD,0BAA0B;AAC5B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qCAAqC;EACrC,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,gEAAgE;AAClE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gEAAgE;AAClE;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,wCAAwC;EACxC,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,wEAAwE;AACxE;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;EACjC,kBAAkB;EAClB,8CAA8C;EAC9C,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sEAAsE;AACtE;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,YAAY;EACZ,mEAAmE;AACrE;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF","sourcesContent":["/* Home Page Styles - OLED Technical */\n\n.home-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--text-primary);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(16px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Header Section */\n.home-header {\n  margin-bottom: 2rem;\n  border-bottom: 1px solid var(--border-color);\n  padding-bottom: 1.5rem;\n}\n\n.home-title {\n  font-family: var(--font-heading);\n  font-size: 2rem;\n  font-weight: 600;\n  color: var(--text-heading);\n  margin-bottom: 0.5rem;\n}\n\n.home-subtitle {\n  font-family: var(--font-body);\n  font-size: 1rem;\n  color: var(--text-secondary);\n}\n\n.btn-refresh-mini {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease-out;\n}\n\n.btn-refresh-mini:hover:not(:disabled) {\n  background: var(--bg-secondary);\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n  transform: translateY(-1px);\n}\n\n.btn-refresh-mini:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-refresh-mini svg {\n  transition: transform 0.4s ease;\n}\n\n.btn-refresh-mini:hover:not(:disabled) svg {\n  transform: rotate(180deg);\n}\n\n/* Logs Section */\n.home-logs-section {\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  padding: 24px;\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 2rem;\n}\n\n.home-logs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.home-logs-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.home-logs-icon {\n  width: 40px;\n  height: 40px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent-primary);\n}\n\n.home-logs-title {\n  font-family: var(--font-heading);\n  font-size: 1.2rem;\n  font-weight: 650;\n  color: var(--text-heading);\n  margin: 0;\n}\n\n.home-logs-subtitle {\n  font-family: var(--font-data);\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  margin: 2px 0 0 0;\n  line-height: 1.15;\n  font-weight: 500;\n}\n\n/* Log Items & Staggered Animation */\n@keyframes slideUpFade {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.home-logs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.home-log-item {\n  background: var(--bg-primary);\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\n  overflow-anchor: none;\n  contain: layout style;\n}\n\n.home-log-item:hover {\n  border-color: var(--accent-primary);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n}\n\n.home-log-item.expanded {\n  border-color: var(--accent-primary);\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);\n}\n\n.log-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.log-item-main-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.log-type-icon-wrapper {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: transform 0.3s ease;\n}\n\n.home-log-item:hover .log-type-icon-wrapper {\n  transform: scale(1.05);\n}\n\n.log-item-title-group {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.log-item-action-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.log-item-action-row .copy-btn {\n  opacity: 0.6;\n}\n\n.log-item-action-row:hover .copy-btn {\n  opacity: 0.85;\n}\n\n.log-item-action {\n  font-family: var(--font-heading);\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-heading);\n  line-height: 1.2;\n}\n\n.log-type-badge {\n  font-family: var(--font-data);\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.log-item-header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.log-item-date {\n  font-family: var(--font-data);\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.btn-log-expand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.home-log-item:hover .btn-log-expand {\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--accent-primary);\n}\n\n.btn-log-expand.expanded {\n  background: var(--accent-primary);\n  color: #fff;\n  transform: rotate(180deg);\n}\n\n/* Expanded body */\n.log-item-body {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.log-item-body.open {\n  grid-template-rows: 1fr;\n}\n\n.log-item-body > div {\n  overflow: hidden;\n}\n\n.log-item-body-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.log-item-details {\n  padding: 0 20px 20px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.log-item-reason {\n  margin: 0 20px;\n  padding: 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-family: var(--font-body);\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.reason-icon {\n  color: var(--accent-warning);\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.log-item-actors-compact {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 0 20px 20px 20px;\n  font-family: var(--font-data);\n  font-size: 0.85rem;\n}\n\n.log-actor-compact, .log-target-compact {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--bg-tertiary);\n  padding: 6px 12px;\n  border-radius: 20px;\n  color: var(--text-secondary);\n}\n\n.log-actor-name, .log-target-name {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.log-item-actors-full {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.log-actor-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  transition: all 0.2s ease;\n}\n\n.log-actor-row.clickable:hover {\n  cursor: pointer;\n  border-color: rgba(37, 99, 235, 0.3);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);\n}\n\n.log-actor-row-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.log-actor-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: rgba(37, 99, 235, 0.08);\n  color: var(--accent-primary);\n}\n\n.log-actor-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.log-actor-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.log-actor-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  letter-spacing: 0.5px;\n}\n\n.log-actor-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.log-actor-role, .log-target-role {\n  padding: 4px 8px;\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--accent-primary);\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n/* Payload Accordion */\n.log-item-payload {\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--bg-primary);\n  overflow-anchor: none;\n}\n\n.payload-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: rgba(0,0,0,0.02);\n  border: none;\n  border-bottom: 1px solid transparent;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.payload-header:hover {\n  background: rgba(0,0,0,0.04);\n  color: var(--text-primary);\n}\n\n.payload-chevron {\n  transition: transform 0.3s ease;\n}\n\n.payload-chevron.open {\n  transform: rotate(180deg);\n}\n\n.payload-body {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.payload-body.open {\n  grid-template-rows: 1fr;\n  border-top: 1px solid var(--border-color);\n}\n\n.payload-content {\n  overflow: hidden;\n}\n\n.log-item-payload pre {\n  padding: 16px;\n  margin: 0;\n  font-family: var(--font-data, monospace);\n  font-size: 0.85rem;\n  color: var(--text-primary);\n  overflow-x: auto;\n  line-height: 1.5;\n  background: var(--bg-tertiary);\n}\n\n.home-logs-empty {\n  text-align: center;\n  padding: 48px;\n  color: var(--text-secondary);\n}\n\n.empty-icon {\n  color: var(--border-color);\n  margin-bottom: 16px;\n}\n\n/* Cleaned up loader */\n.home-logs-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  color: var(--text-secondary);\n  font-family: var(--font-data);\n  font-size: 0.9rem;\n  gap: 16px;\n}\n\n@media (max-width: 768px) {\n  .home-log-item {\n    border-radius: 8px;\n  }\n  \n  .log-item-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .log-item-header-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .log-item-actors-compact {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .log-item-actors-full {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ============================ Home tabs ============================ */\n.home-tabs {\n  display: inline-flex;\n  gap: 4px;\n  margin-bottom: 24px;\n  padding: 5px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);\n}\n\n.home-tab {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 9px 20px;\n  background: transparent;\n  border: none;\n  border-radius: 9px;\n  position: relative;\n  overflow: hidden;\n  font-family: var(--font-heading);\n  font-size: 0.875rem;\n  font-weight: 600;\n  white-space: nowrap;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: color 0.25s ease;\n}\n\n.home-tab:hover:not(.active) {\n  color: var(--text-primary);\n}\n\n.home-tab.active {\n  color: #fff;\n}\n\n.home-tab-active-bg {\n  position: absolute;\n  inset: 0;\n  background: var(--accent-primary);\n  border-radius: 9px;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);\n  z-index: 0;\n  pointer-events: none;\n}\n\n.home-tab-content {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ===================== Order moderation logs ===================== */\n.order-log-title {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.order-log-badges {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.order-log-attempts {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-family: var(--font-data);\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  padding: 2px 8px;\n}\n\n/* CSV export buttons */\n.order-logs-export-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.order-logs-export-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n/* AI error block */\n.order-log-error {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 4px 0 18px;\n  padding: 16px 18px 16px 28px;\n  background: rgba(239, 68, 68, 0.06);\n  border: 1px solid rgba(239, 68, 68, 0.22);\n  border-radius: 10px;\n}\n\n.order-log-error::before {\n  content: \"\";\n  position: absolute;\n  left: 14px;\n  top: 14px;\n  bottom: 14px;\n  width: 3px;\n  border-radius: 99px;\n  background: var(--accent-error);\n}\n\n.order-log-error-header {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.order-log-error-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n  color: var(--accent-error);\n  background: rgba(239, 68, 68, 0.12);\n  border-radius: 6px;\n}\n\n.order-log-error-label {\n  font-family: var(--font-data);\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--accent-error);\n}\n\n.order-log-error-text {\n  padding-left: 31px;\n  font-size: 0.88rem;\n  line-height: 1.5;\n  color: var(--text-primary);\n  word-break: break-word;\n}\n\n.order-log-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* User id row */\n.order-log-id {\n  font-family: var(--font-data);\n  font-size: 0.85rem !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.2px;\n  word-break: break-all;\n}\n\n.order-log-row-chevron {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  color: var(--text-secondary);\n  opacity: 0.5;\n  transition: transform 0.2s ease, opacity 0.2s ease, color 0.2s ease;\n}\n\n.log-actor-row.clickable:hover .order-log-row-chevron {\n  opacity: 1;\n  color: var(--accent-primary);\n  transform: translateX(3px);\n}\n\n@media (max-width: 768px) {\n  .home-tabs {\n    display: flex;\n    width: 100%;\n  }\n\n  .home-tab {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
